import { observer } from 'mobx-react';

import { SIZE_MEDIUM } from '@/common/components/Label/Label';
import DriveAccessStatus from '@/drive/components/DriveAccessStatus/DriveAccessStatus';
import { getGridItemType } from '@/drive/components/DriveGrid/GridItem/GridItem.utils';
import { CollectionTreeItem } from '@/drive/entities/DriveTreeItem/CollectionTreeItem';
import { DriveTreeItem } from '@/drive/entities/DriveTreeItem/DriveTreeItem';
import { FolderTreeItem } from '@/drive/entities/DriveTreeItem/FolderTreeItem';

import styles from './DriveModalTreeItemMeta.module.css';

export interface DriveModalTreeItemMetaProps {
  item: DriveTreeItem;
}

function DriveModalTreeItemMeta(props: DriveModalTreeItemMetaProps) {
  const { item } = props;

  const isContainer = item instanceof FolderTreeItem || item instanceof CollectionTreeItem;

  return (
    <div className={styles.meta}>
      <DriveAccessStatus item={item} size={SIZE_MEDIUM} className={styles.accessStatus} shouldHidePrivate />

      {isContainer && <span aria-label="Destination type">{getGridItemType(item.toDriveItem())}</span>}
    </div>
  );
}

export default observer(DriveModalTreeItemMeta);
